(function () {
  function init(root) {
    const track = root.querySelector(".blog-slider__track");
    if (!track) return;

    const prev = root.querySelector(".blog-slider__btn.prev");
    const next = root.querySelector(".blog-slider__btn.next");
    const autoplaySeconds = Number(root.dataset.autoplay || 0);

    const slides = Array.from(track.querySelectorAll(".blog-slide"));
    if (slides.length <= 1) return;

    function getSlideMetrics() {
      const slide = track.querySelector(".blog-slide");
      if (!slide) return { width: track.clientWidth, gap: 0 };

      const slideStyle = window.getComputedStyle(slide);
      const marginLeft = parseFloat(slideStyle.marginLeft || 0);
      const marginRight = parseFloat(slideStyle.marginRight || 0);

      // Total step = slide width + both margins
      return { 
        width: slide.getBoundingClientRect().width, 
        gap: marginLeft + marginRight 
      };
    }

    function slideNext() {
      const { width, gap } = getSlideMetrics();
      const step = width + gap;
      const maxScroll = track.scrollWidth - track.clientWidth;
      const nextPos = track.scrollLeft + step;

      if (nextPos >= maxScroll - 2) {
        track.scrollTo({ left: 0, behavior: "auto" });
      } else {
        track.scrollBy({ left: step, behavior: "smooth" });
      }
    }

    function slidePrev() {
      const { width, gap } = getSlideMetrics();
      const step = width + gap;
      const prevPos = track.scrollLeft - step;

      if (prevPos <= 2) {
        track.scrollTo({ left: track.scrollWidth - track.clientWidth, behavior: "auto" });
      } else {
        track.scrollBy({ left: -step, behavior: "smooth" });
      }
    }

    // Buttons
    prev?.addEventListener("click", (e) => {
      e.preventDefault();
      slidePrev();
    });

    next?.addEventListener("click", (e) => {
      e.preventDefault();
      slideNext();
    });

    // Autoplay
    let interval = null;

    function stopAutoplay() {
      if (interval) clearInterval(interval);
      interval = null;
    }

    function startAutoplay() {
      if (autoplaySeconds <= 0) return;
      stopAutoplay();
      interval = setInterval(slideNext, autoplaySeconds * 1000);
    }

    startAutoplay();

    root.addEventListener("mouseenter", stopAutoplay);
    root.addEventListener("mouseleave", startAutoplay);
    root.addEventListener("touchstart", stopAutoplay, { passive: true });

    // Shared drag state for mouse and touch
    let isDown = false;
    let startX = 0;
    let startScrollLeft = 0;
    let dragged = false;

    // --- Mobile touch UX enhancements ---
    // Velocity tracking for momentum-based snapping
    let touchStartTime = 0;
    let lastTouchX = 0;
    let lastTouchTime = 0;
    let velocityX = 0;



    track.style.cursor = "grab";

    // --- Mouse drag support ---
    track.addEventListener("mousedown", (e) => {
      if (e.button !== 0) return;
      isDown = true;
      dragged = false;
      startX = e.pageX;
      startScrollLeft = track.scrollLeft;
      track.style.cursor = "grabbing";
      stopAutoplay();
      e.preventDefault(); // avoid selecting text while dragging
    });

    window.addEventListener("mousemove", (e) => {
      if (!isDown) return;
      const dx = e.pageX - startX;
      if (Math.abs(dx) > 3) dragged = true;
      track.scrollLeft = startScrollLeft - dx;
    });

    window.addEventListener("mouseup", () => {
      if (!isDown) return;
      isDown = false;
      track.style.cursor = "grab";
      startAutoplay();
      snapAfterDrag();
    });

    // --- Touch drag support for mobile (enhanced UX) ---
    // Direction lock: null = undecided, 'horizontal' = slider, 'vertical' = page scroll
    let touchDirection = null;
    let startY = 0;

    track.addEventListener("touchstart", (e) => {
      if (e.touches.length !== 1) return;
      isDown = true;
      dragged = false;
      touchDirection = null; // Reset direction lock
      startX = e.touches[0].pageX;
      startY = e.touches[0].pageY;
      startScrollLeft = track.scrollLeft;
      
      // Initialize velocity tracking
      touchStartTime = Date.now();
      lastTouchX = startX;
      lastTouchTime = touchStartTime;
      velocityX = 0;

      stopAutoplay();
    }, { passive: true });

    track.addEventListener("touchmove", (e) => {
      if (!isDown || e.touches.length !== 1) return;
      
      const currentX = e.touches[0].pageX;
      const currentY = e.touches[0].pageY;
      const currentTime = Date.now();
      const dx = currentX - startX;
      const dy = currentY - startY;
      
      // Determine direction on first significant movement
      if (touchDirection === null && (Math.abs(dx) > 5 || Math.abs(dy) > 5)) {
        // If more vertical than horizontal, let browser handle it (page scroll)
        if (Math.abs(dy) > Math.abs(dx)) {
          touchDirection = 'vertical';
          isDown = false; // Release our hold
          startAutoplay();
          return;
        }
        touchDirection = 'horizontal';
      }
      
      // Only handle horizontal swipes
      if (touchDirection !== 'horizontal') return;
      
      if (Math.abs(dx) > 3) dragged = true;
      
      // Track velocity (pixels per millisecond)
      const timeDelta = currentTime - lastTouchTime;
      if (timeDelta > 0) {
        // Use weighted average for smoother velocity
        const instantVelocity = (currentX - lastTouchX) / timeDelta;
        velocityX = velocityX * 0.3 + instantVelocity * 0.7;
      }
      
      lastTouchX = currentX;
      lastTouchTime = currentTime;
      
      track.scrollLeft = startScrollLeft - dx;
    }, { passive: true });

    track.addEventListener("touchend", (e) => {
      if (!isDown) return;
      isDown = false;
      
      const touchDuration = Date.now() - touchStartTime;
      const totalDrag = track.scrollLeft - startScrollLeft;
      
      // Determine snap direction based on velocity and distance
      const { width, gap } = getSlideMetrics();
      const step = width + gap;
      
      // Thresholds for determining intent
      const SWIPE_VELOCITY_THRESHOLD = 0.3; // px/ms - lower = more sensitive
      const DISTANCE_THRESHOLD = step * 0.15; // 15% of slide width
      const QUICK_SWIPE_DURATION = 300; // ms
      
      let snapDirection = 0; // -1 = prev, 0 = stay/nearest, 1 = next
      
      // Fast swipe detection (velocity-based)
      if (Math.abs(velocityX) > SWIPE_VELOCITY_THRESHOLD && touchDuration < QUICK_SWIPE_DURATION) {
        snapDirection = velocityX < 0 ? 1 : -1; // Negative velocity = swiped left = go next
      }
      // Distance-based intent (for slower drags)
      else if (Math.abs(totalDrag) > DISTANCE_THRESHOLD) {
        snapDirection = totalDrag > 0 ? 1 : -1;
      }
      
      snapWithIntent(snapDirection, step);
      startAutoplay();
      
      // Reset dragged a tick later so normal clicks/taps work
      setTimeout(() => {
        dragged = false;
      }, 0);
    }, { passive: true });

    // Note: CSS scroll-snap handles native momentum snapping automatically

    // --- Snap with directional intent ---
    function snapWithIntent(direction, step) {
      const maxScroll = track.scrollWidth - track.clientWidth;
      const currentSlide = Math.round(startScrollLeft / step);
      
      let targetSlide;
      
      if (direction === 1) {
        // Go to next slide
        targetSlide = currentSlide + 1;
      } else if (direction === -1) {
        // Go to previous slide
        targetSlide = currentSlide - 1;
      } else {
        // Snap to nearest
        targetSlide = Math.round(track.scrollLeft / step);
      }
      
      // Handle bounds with looping
      const totalSlides = slides.length;
      let targetScroll = targetSlide * step;
      
      if (targetScroll >= maxScroll) {
        track.scrollTo({ left: 0, behavior: "smooth" });
      } else if (targetScroll < 0) {
        track.scrollTo({ left: maxScroll, behavior: "smooth" });
      } else {
        track.scrollTo({ left: targetScroll, behavior: "smooth" });
      }
    }



    // --- Snap to nearest slide after mouse drag ---
    function snapAfterDrag() {
      const { width, gap } = getSlideMetrics();
      const step = width + gap;
      const maxScroll = track.scrollWidth - track.clientWidth;

      // Keep jump-loop sane when dragging beyond bounds
      if (track.scrollLeft <= 0) track.scrollLeft = maxScroll;
      if (track.scrollLeft >= maxScroll) track.scrollLeft = 0;

      // Snap to nearest slide after an actual drag
      if (dragged && step > 0) {
        const snapped = Math.round(track.scrollLeft / step) * step;
        track.scrollTo({ left: snapped, behavior: "smooth" });
      }

      // Reset dragged a tick later so normal clicks/taps work
      setTimeout(() => {
        dragged = false;
      }, 0);
    }

    // Prevent accidental clicks on links INSIDE the track after dragging
    track.addEventListener(
      "click",
      (e) => {
        if (dragged) {
          e.preventDefault();
          e.stopPropagation();
        }
      },
      true
    );
  }

  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".blog-slider").forEach(init);
  });

  document.addEventListener("shopify:section:load", (e) => {
    const root = e.target.querySelector?.(".blog-slider");
    if (root) init(root);
  });
})();